import React, { useMemo } from 'react';
import { CERTIFICATES, certificates } from '../../certificate/certificates';
import CertificateItem from '../../certificate/CertificateItem';
import { useFormik } from 'formik';
import { Yup } from '../../../helpers/Yup';
import { isEmpty } from 'lodash';
import { Button } from '../../../components/UI-CHAKRA/Button';
import { Text } from '../../../components/UI-CHAKRA/Text';
import { FormLabel } from '../../../components/UI-CHAKRA/FormLabel';
import { Input } from '../../../components/UI-CHAKRA/Input/Input';
import { FormErrorMessage } from '../../../components/UI-CHAKRA/FormErrorMessage';
import { FormControl } from '../../../components/UI-CHAKRA/FormControl';
import BaseDialog from '../../../components/Dialogs/BaseDialog';
import { Flex } from '../../../components/UI-CHAKRA/Flex';

interface AuthenticateEvalProps {
  onConfirm(pin: string): void;
  onCancel(): void;
  certificate: CERTIFICATES;
  passwordLabel: string;
}

const AuthenticateEvalSchema = Yup.object().shape({
  password: Yup.string().required('Informe uma senha'),
});

export function AuthenticateWithPin(props: AuthenticateEvalProps) {
  const { onConfirm, onCancel } = props;

  const formik = useFormik({
    initialValues: {
      password: '',
    },
    onSubmit: () => {},
    validationSchema: AuthenticateEvalSchema,
  });

  const certificateItem = useMemo(() => {
    const certificate = certificates.find((certificate) => certificate.value === props.certificate);
    return certificate ? <CertificateItem certificate={certificate} active={false} /> : null;
  }, [props.certificate]);

  const handleOnConfirm = async () => {
    const validated = await formik.validateForm();

    if (!isEmpty(validated)) return;

    onConfirm(formik.values.password);
  };

  const onSubmitPassword = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleOnConfirm();
  };

  return (
    <BaseDialog isOpen={true} onClose={onCancel}>
      <Text fontWeight={700} fontSize={'18px'}>
        Digite a senha do seu certificado
      </Text>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ width: 101, marginRight: 16 }}>{certificateItem}</div>
        <form data-testid="auth-form" onSubmit={onSubmitPassword} autoComplete="off">
          <FormControl isInvalid={!!formik.errors.password} marginTop={'22px'}>
            <FormLabel>{props.passwordLabel}</FormLabel>
            <Input
              name={'password'}
              w={'100%'}
              value={formik.values.password}
              onChange={formik.handleChange}
              type={'password'}
              autoFocus
              data-testid={'password'}
              autoComplete="off"
            />
            <FormErrorMessage>{formik.errors.password}</FormErrorMessage>
          </FormControl>
        </form>
      </div>

      <Flex padding={'24px'} gap={'12px'} justifyContent={'flex-end'}>
        <Button
          width={'121px'}
          onClick={onCancel}
          variant={'ghost'}
          bg={'gray.lightest'}
          color={'typography.darkest'}
          boxShadow={'none'}
          fontWeight={400}
          fontSize={'14px'}
        >
          Cancelar
        </Button>
        <Button
          width={'121px'}
          onClick={handleOnConfirm}
          variant={'ghost'}
          backgroundColor={'info.main'}
          color={'#fff'}
        >
          Confirmar
        </Button>
      </Flex>
    </BaseDialog>
  );
}
